export default {
  base: {
    bg: 'grey-0',
    textDecoration: 'none',
    variant: 'spark.base.wrapper',
    name: {
      color: 'grey-100',
      fontSize: ['xxxs', 'xxs']
    },
    subtitle: {
      textDecoration: 'none',
      color: 'grey-60',
      fontSize: 'xxxs'
    },
    hover: {
      bg: 'grey-05',
      color: 'grey-100'
    },
    focus: {
      bg: 'grey-0',
      color: 'grey-100',
      outline: '2px solid',
      outlineColor: 'cyan'
    }
  }
};